import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';

import JEENEETOpenBookListComponent from './JEENEETOpenBookListComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faVideo, 
    faPencil,  
    faBookReader,
    faDownload,
    faCrown
} from '@fortawesome/free-solid-svg-icons';
import './OpenTextBookHome.css';

function JEENEETOpenBookHome() {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();

    const [userId, setUserId] = useState(authState.user._id);
    const [bookId, setBookId] = useState("678816715e96c6957ecb0c43");
    const [isJEENEETBook, setIsJEENEETBook] = useState(false);
    const [isBookChecked, setIsBookChecked] = useState(false);

    const fetchMyBooks = useCallback(() => {
        const config = {
            url: "/mybooks/jeeneetbookbuyingstatus",
            method: "post",
            headers: { Authorization: authState.token },
            data: {userId: userId}
        };
    
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && typeof response.bookbuyingstatus === "boolean") {
                    setIsJEENEETBook(response.bookbuyingstatus);
                } else {
                    console.error("Invalid response format: Book not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching MyBooks:", error);
            });
      }, [authState.token, fetchData]);
    
    
      useEffect(() => {
          if (!authState.isLoggedIn) return;
          fetchMyBooks();
      }, [authState.isLoggedIn, fetchMyBooks]);

    return (
        <MainLayout>
            <div className="min-h-screen py-8 bg-gradient-to-r from-blue-500 via-gray-500 to-yellow-100 mt-12">
                <h2 className='text-xl font-bold text-white text-center mb-4'>
                    My JEE/NEET Cloud Book
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mb-4 mx-2">
                    <Link to={isJEENEETBook  ? "/jeeneetopenbook-pagelist" : "#"} className="bg-orange-500 hover:bg-orange-600 rounded-lg p-4 shadow-md text-center text-black">
                        <FontAwesomeIcon icon={faPencil} className="mb-2 text-yellow-500 text-3xl" size="1x" />
                        <p>My Own Pages</p>
                    </Link>
                    <Link to={isJEENEETBook  ? "/flipbook" : "#"} state={{ bookId: "6703b08dd958602c3c46385b" }} className="bg-red-600 hover:bg-red-700 rounded-lg p-4 shadow-md text-center text-white">
                        <FontAwesomeIcon icon={faBookReader} className="mb-2 text-yellow-300 text-xl" size="1x" />
                        <p>FlipNotes</p>
                    </Link>
                    <Link to={isJEENEETBook  ?"/videobook" : "#"} state={{ bookId: "6703b08dd958602c3c46385b" }}  className="bg-red-600 hover:bg-red-700 rounded-lg p-4 shadow-md text-center text-white">
                        <FontAwesomeIcon icon={faVideo} className="mb-2 text-yellow-500 text-xl" size="1x" />
                        <p>VideoBook</p>
                    </Link>
                    <Link to="" className="bg-lime-400  rounded-lg p-4 shadow-md text-center text-gray-500">
                        <FontAwesomeIcon icon={faDownload} className="mb-2 text-yellow-500 text-3xl" size="1x" />
                        <p>Download Book<sup>*</sup>
                        <FontAwesomeIcon icon={faCrown} className="mb-2 text-yellow-500 text-m" size="1x" /></p>
                    </Link>
                    <Link to="" className="bg-lime-400 rounded-lg p-4 shadow-md text-center text-gray-500">
                        <FontAwesomeIcon icon={faDownload} className="mb-2 text-yellow-500 text-3xl" size="1x" />
                        <p>Download Notes<sup>*</sup>
                        <FontAwesomeIcon icon={faCrown} className="mb-2 text-yellow-500 text-m" size="1x" /></p>
                    </Link>
                    <Link to="" className="bg-lime-400  rounded-lg p-4 shadow-md text-center text-gray-500">
                        <FontAwesomeIcon icon={faDownload} className="mb-2 text-yellow-500 text-3xl" size="1x" />
                        <p>Download Book with Notes<sup>*</sup>
                        <FontAwesomeIcon icon={faCrown} className="mb-2 text-yellow-500 text-m" size="1x" /></p>
                    </Link>
                    {/* <Link to="" className="bg-purple-600 hover:bg-purple-700 rounded-lg p-4 shadow-md text-center text-gray-400">
                        <FontAwesomeIcon icon={faChalkboardTeacher} className="mb-2 text-yellow-300 text-xl" size="1x" />
                        <p>My Mentors</p>
                    </Link> */}
                    {/* <Link to="" className="bg-purple-600 hover:bg-purple-700 rounded-lg p-4 shadow-md text-center text-gray-400">
                        <FontAwesomeIcon icon={faUserFriends} className="mb-2 text-yellow-300 text-xl" size="1x" />
                        <p>My Digital Co-Readers</p>
                    </Link> */}
                    {/* <Link to="" className="bg-purple-600 hover:bg-purple-700 rounded-lg p-4 shadow-md text-center text-gray-400">
                        <FontAwesomeIcon icon={faUserCheck} className="mb-2 text-yellow-300 text-xl" size="1x" />
                        <p>Mentoring</p>
                    </Link> */}
                    {/* <Link to="" className="bg-purple-600 hover:bg-purple-700 rounded-lg p-4 shadow-md text-center text-gray-400">
                        <FontAwesomeIcon icon={faUsers} className="mb-2 text-yellow-300 text-xl" size="1x" />
                        <p>My Flyers on The Wall</p>
                    </Link> */}
                    {/* <Link to="" className="bg-purple-600 hover:bg-purple-700 rounded-lg p-4 shadow-md text-center text-gray-400">
                        <FontAwesomeIcon icon={faEye} className="mb-2 text-yellow-300 text-xl" size="1x" />
                        <p>I Am Flying On The Wall</p>
                    </Link> */}
                </div>
                <div className='mx-2'>
                    <JEENEETOpenBookListComponent />
                </div>
            </div>
    </MainLayout>
    );
}

export default JEENEETOpenBookHome;
